import { Button } from '@mui/material'
import { GridSaveAltIcon, GridToolbarContainer, gridFilteredSortedRowIdsSelector, gridPaginatedVisibleSortedGridRowIdsSelector, useGridApiContext } from '@mui/x-data-grid'
import React from 'react'

const BulkUploadHistoryGridToolBar = () => {
  const apiRef = useGridApiContext()
  const handleExport = (options: any) => apiRef.current.exportDataAsCsv(options)
  return (
    <GridToolbarContainer>
      <Button
        startIcon={<GridSaveAltIcon />}
        onClick={() => handleExport({
          getRowsToExport: ({ apiRef }: { apiRef: any }) => gridFilteredSortedRowIdsSelector(apiRef)
        })}
      >
        Export
      </Button>
    </GridToolbarContainer>
  )
}

export default BulkUploadHistoryGridToolBar